import React, { Component } from 'react';
import actions from '../actions';
import entityActions from '../../entities/actions';
import sharedActions from '../../shared/actions';
import { connect } from 'react-redux';
import TerminalsForm from './../components/TerminalsForm';
import Validators from './../../shared/utils/Validators';
import { I18n } from 'react-redux-i18n';
import _ from '../../shared/utils/ObjectUtils';

class TerminalsFormContainer extends Component {
    constructor(props) {
        super(props);
        this.state = {
            viewMode: !_.isNilOrEmpty(props.terminalId),
            editMode: false,
            createMode: _.isNilOrEmpty(props.terminalId),
            alert: {
                show: false
            },
            terminalFormData: {
                terminalIdentifier: {
                    value: undefined,
                    error: undefined,
                    required: true
                },
                name: {
                    value: undefined,
                    required: false
                },
                profile: {
                    value: undefined,
                    data: [],
                    required: true
                },
                entity: {
                    value: undefined,
                    data: [],
                    required: true
                },
                allowAutoProvisioning: {
                    value: undefined,
                    error: undefined,
                    required: true
                },
                keepAliveTimeMinutes: {
                    value: 15,
                    error: undefined,
                    required: true
                },
                lastCommunication: {
                    value: undefined,
                    error: undefined,
                    required: false
                },
                status: {
                    value: undefined,
                    error: undefined,
                    required: false
                },
                enabled: {
                    value: undefined,
                    error: undefined,
                    required: true
                },
                location: {
                    value: {
                        latitude: undefined,
                        longitude: undefined,
                    },
                    error: undefined,
                    required: true
                },
            }
        }
    }

    componentDidMount() {
        const { 
            terminalId, 
            getEntityList,
            getTerminalData,
            getTerminalProfiles
        } = this.props;
        
        if (terminalId) {
            getTerminalData(terminalId);
        }
        getEntityList();
        getTerminalProfiles();
    };

    componentWillUnmount() {
        this.props.updateCustomTitle();
        this.props.updateCustomBreadcrumbs();
    }

    componentWillReceiveProps(nextProps) {
        //Handle Error, Edit and Create
        if (this.props.loadingDeleteRequest && !nextProps.loadingDeleteRequest) {
            if (nextProps.terminalWasDeleted) {
                this.handleTerminalDeleteSuccess()
            } else {
                this.handleTerminalDeleteError(nextProps.error)
            }
        } else if (this.props.loadingCreateRequest && !nextProps.loadingCreateRequest){
            if (nextProps.terminalWasCreated) {
                this.handleTerminalCreateSuccess()
            } else {
                this.handleTerminalCreateError(nextProps.error)
            }
        } else if (this.props.loadingEditRequest && !nextProps.loadingEditRequest){
            if (nextProps.terminalWasEdited) {
                this.handleTerminalEditSuccess()
            } else {
                this.handleTerminalEditError(nextProps.error)
            }
        } else if (this.props.loadingTerminal && !nextProps.loadingTerminal) {
            this.handleTerminalLoadingCompleted(nextProps.terminalData);
        }
    };

    handleTerminalLoadingCompleted = terminalData => {
        const { 
            updateCustomTitle,
            updateCustomBreadcrumbs
        } = this.props;

        updateCustomTitle(terminalData.name);
        updateCustomBreadcrumbs([{
            link: "/terminals",
            name: I18n.t('routes.terminals')
        }, {
            link: "/terminals/" + terminalData.id,
            name: terminalData.name
        }]);

        this.setState({
            terminalFormData: {
                ...this.state.terminalFormData,
                ...Object.entries(terminalData).reduce(
                    (acc, [key, value]) => ({
                        ...acc,
                        [key]: {
                            ...acc[key],
                            ...this.state.terminalFormData[key],
                            value: value
                        }
                    }), {})
            }
        })
    }

    handleFieldChange = (id, value) => {
        this.setState({
            terminalFormData: {
                ...this.state.terminalFormData,
                [id]: {
                    ...this.state.terminalFormData[id],
                    value: value
                }
            }
        }, () => {
            if(_.has(this.state.terminalFormData[id], 'required')) {
                this.validateField(id);
            }
        })
    };

    validateField = (key) => {
        let { terminalFormData } = this.state;
        let error = null;
        switch (key) {
            case "keepAliveTime":
                error = error = !Validators.isInteger(terminalFormData[key].value) ? I18n.t('terminals.errors.invalidKeepAliveTime') : undefined;
                break;
            default:
                if (!_.isNilOrEmpty(terminalFormData[key].error) &&
                    terminalFormData[key].required &&
                    !_.isNilOrEmpty(terminalFormData[key].value) ) {
                    error = undefined;
                } else if(terminalFormData[key].required &&
                    _.isNilOrEmpty(terminalFormData[key].value)) {
                    error = I18n.t('forms.errors.emptyRequiredField')
                }
                break;
        }
        if (error !== terminalFormData[key].error) {
            terminalFormData[key].error = error;
            this.setState({
                terminalFormData,
            });
        }
    };

    handleOnFieldBlur = (key) => {
        this.validateField(key)
    };

    handleSubmitClick = () => {
        let { editMode, terminalFormData } = this.state;
        const { terminalId, editTerminal, createTerminal } = this.props;
        let formHasErrors = false;

        _.forOwn(terminalFormData, field => {
            if((field.required && _.isNilOrEmpty(field.value))) {
                field.error = I18n.t('forms.errors.emptyRequiredField');
                formHasErrors = true;
            } else if(!_.isNilOrEmpty(field.error)) {
                formHasErrors = true;
            } else {
                field.error = undefined;
            }
        })

        if(!formHasErrors) {
            const formDataToBeSubmitted = Object.entries(terminalFormData).reduce((acc, keyValuePair) => {
                return {
                    ...acc,
                    [keyValuePair[0]]: keyValuePair[1].value,
                }
            }, { })
            const terminalIdentifier = formDataToBeSubmitted.terminalIdentifier;
            if (editMode) {
                this.setState({
                    alert: {
                        show: true,
                        type: "warning",
                        title: I18n.t('terminals.alerts.edit.title'),
                        html: I18n.t('terminals.alerts.edit.text', {terminal: terminalIdentifier}),
                        confirmButtonText: I18n.t('forms.submit'),
                        cancelButtonText: I18n.t('forms.cancel'),
                        onCancel: this.hideAlert,
                        onConfirm: () => {
                            editTerminal(terminalId, formDataToBeSubmitted)
                        }
                    }
                })
            } else {
                this.setState({
                    alert: {
                        show: true,
                        type: "warning",
                        title: I18n.t('terminals.alerts.create.title'),
                        html: I18n.t('terminals.alerts.create.text', {terminal: terminalIdentifier}),
                        confirmButtonText: I18n.t('forms.submit'),
                        cancelButtonText: I18n.t('forms.cancel'),
                        onCancel: this.hideAlert,
                        onConfirm: () => {
                            createTerminal(formDataToBeSubmitted)
                        }
                    }
                })
            }
        } else {
            this.setState({
                terminalFormData,
            });
        }
    };

    handleEditClick =() => {
        const { editMode } = this.state;
        const { terminalData } = this.props;

        if (editMode) {
            this.setState({
                ...this.state,
                editMode: false,
                viewMode: true,
                terminalFormData:
                    Object.entries(terminalData).reduce((acc, [key, value]) => {
                        return {
                            ...acc,
                            [key]: {
                                ...this.state.terminalFormData[key],
                                value: value,
                                error: undefined,
                            }
                        }
                    }, {})
            })
        } else {
            this.setState({
                viewMode: false,
                editMode: true
            })
        }
    }

    hideAlert = () => {
        this.setState({
            alert: {
                show: false
            }
        })
    }

    handleBackClick = () => {
        this.props.resetTerminalForm();
        this.hideAlert();
        this.props.history.push({
            pathname: '/terminals',
            state: { 
                searchFieldsData : this.props.location.state?.searchFieldsData, 
                universalSearchField :  this.props.location.state?.universalSearchField
            }
        });
    }

    handleDeleteClick = () => {
        const { terminalId, deleteTerminal } = this.props;
        const {
            terminalFormData: {
                terminalIdentifier: {
                    value: terminalIdentifier
                }
            }
        } = this.state;

        this.setState({
            alert: {
                show: true,
                type: "warning",
                title: I18n.t('terminals.alerts.delete.title'),
                html: I18n.t('terminals.alerts.delete.text', {terminal: terminalIdentifier}),
                confirmButtonText: I18n.t('forms.delete'),
                cancelButtonText: I18n.t('forms.cancel'),
                onCancel: this.hideAlert,
                onConfirm: () => {
                    deleteTerminal(terminalId)
                }
            }
        })
    }

    handleTerminalDeleteSuccess = () => {
        const {
            terminalFormData: {
                terminalIdentifier: {
                    value: terminalIdentifier
                }
            }
        } = this.state;

        this.setState({
            alert: {
                show: true,
                type: 'success',
                title: I18n.t('terminals.alerts.delete.success.title'),
                html: I18n.t('terminals.alerts.delete.success.text', {terminal: terminalIdentifier}),
                confirmButtonText: I18n.t('forms.ok'),
                onCancel: this.handleBackClick,
                onConfirm: this.handleBackClick
            }
        })
    }

    handleTerminalDeleteError = error => {
        this.setState({
            alert: {
                show: true,
                type: 'error',
                title: I18n.t('terminals.alerts.delete.error.title'),
                html: I18n.t('terminals.alerts.delete.error.text'),
                confirmButtonText: I18n.t('forms.ok'),
                onConfirm: this.hideAlert
            }
        })
    }

    handleTerminalCreateSuccess = () => {
        const {
            terminalFormData: {
                terminalIdentifier: {
                    value: terminalIdentifier
                }
            }
        } = this.state;

        this.setState({
            alert: {
                show: true,
                type: 'success',
                title: I18n.t('terminals.alerts.create.success.title'),
                html: I18n.t('terminals.alerts.create.success.text', {terminal: terminalIdentifier}),
                confirmButtonText: I18n.t('forms.ok'),
                onCancel: this.handleBackClick,
                onConfirm: this.handleBackClick
            }
        })
    }

    handleTerminalCreateError = error => {
        this.setState({
            alert: {
                show: true,
                type: 'error',
                title: I18n.t('terminals.alerts.create.error.title'),
                html: I18n.t('terminals.alerts.create.error.text'),
                confirmButtonText: I18n.t('forms.ok'),
                onConfirm: this.hideAlert
            }
        })
    }

    handleTerminalEditSuccess = () => {
        const {
            terminalFormData: {
                terminalIdentifier: {
                    value: terminalIdentifier
                }
            }
        } = this.state;

        this.setState({
            alert: {
                show: true,
                type: 'success',
                title: I18n.t('terminals.alerts.edit.success.title'),
                html: I18n.t('terminals.alerts.edit.success.text', {terminal: terminalIdentifier}),
                confirmButtonText: I18n.t('forms.ok'),
                onCancel: this.handleBackClick,
                onConfirm: this.handleBackClick
            }
        })
    }

    handleTerminalEditError = error => {
        this.setState({
            alert: {
                show: true,
                type: 'error',
                title: I18n.t('terminals.alerts.edit.error.title'),
                html: I18n.t('terminals.alerts.edit.error.text'),
                confirmButtonText: I18n.t('forms.ok'),
                onConfirm: this.hideAlert
            }
        })
    }

    render() {
        const { 
            createMode, 
            editMode,
            viewMode,  
            terminalFormData, 
            alert 
        } = this.state;

        const { 
            entityList, 
            terminalProfilesList, 
            loadingDeleteRequest, 
            loadingCreateRequest, 
            loadingEditRequest,
            history 
        } = this.props;

        const entityWithName = entityList.find(entityInstance => entityInstance.value === terminalFormData.entity.value);

        return <TerminalsForm
            editMode={editMode}
            createMode={createMode}
            viewMode={viewMode}
            alert={{
                ...alert,
                loading: loadingDeleteRequest || loadingCreateRequest || loadingEditRequest
            }}

            terminalFormData={terminalFormData}
            entityList={entityList}
            terminalProfilesList={terminalProfilesList}
            entityWithName={entityWithName}

            handleFieldChange={this.handleFieldChange}
            handleOnFieldBlur={this.handleOnFieldBlur}
            handleSubmitClick={this.handleSubmitClick}

            handleEditClick={this.handleEditClick}
            handleDeleteClick={this.handleDeleteClick}
            handleBackClick={this.handleBackClick}

            history={history}
        />
    }
}

const mapStateToProps = ({ 
    terminalsReducer, 
    entitiesReducer 
}) => {
    return {
        terminalData: terminalsReducer.terminalData,
        loadingTerminal: terminalsReducer.loading,
        error: terminalsReducer.error,

        loadingDeleteRequest: terminalsReducer.loadingDeleteRequest,
        terminalWasDeleted: terminalsReducer.terminalWasDeleted,

        loadingCreateRequest: terminalsReducer.loadingCreateRequest,
        terminalWasCreated: terminalsReducer.terminalWasCreated,

        loadingEditRequest: terminalsReducer.loadingEditRequest,
        terminalWasEdited: terminalsReducer.terminalWasEdited,

        terminalProfilesList: terminalsReducer.terminalProfilesList,
        entityList: entitiesReducer.entityList
    };
};

const mapDispatchToProps = {
    getTerminalData: actions.getTerminalData,
    createTerminal: actions.createTerminal,
    editTerminal: actions.editTerminal,
    deleteTerminal: actions.deleteTerminal,
    resetTerminalForm: actions.resetTerminalForm,
    getTerminalProfiles: actions.getTerminalProfiles,

    getEntityList: entityActions.getEntityList,
    updateCustomTitle: sharedActions.updateCustomTitle,
    updateCustomBreadcrumbs: sharedActions.updateCustomBreadcrumbs
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(TerminalsFormContainer);
